
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#56BFC7","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","clip-path":"url(#clip0_25476_41378)"}},[_c('path',{attrs:{"d":"M23.644 14.367l-7.063 9.428-4.714-3.53M9.076 9.224a3.857 3.857 0 100-7.714 3.857 3.857 0 000 7.714zM5.645 22.081H1.36V19.51a7.714 7.714 0 0113.166-5.452"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_25476_41378"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.5 .652)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    